import { Grid, ListItemText, useMediaQuery } from "@mui/material";
import { Visibility } from "@mui/icons-material";

import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import type { IPredictionQuestion } from "@framework/types";
import { ListAction, ListActions, StyledListItem, StyledListWrapper, StyledPagination } from "@framework/styled";
import { useDialogView, useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";

import { PredictionQuestionDialogView } from "./view";

const PREDICTION_QUESTION_URL = "/prediction/question";
const PREDICTION_QUESTION_VIEW_DIALOG_KEY = "predictionQuestion";

export const PredictionQuestion = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IPredictionQuestion>
  >(PREDICTION_QUESTION_URL, { enableInfiniteScroll: isMd });

  const { viewItem, handleView, viewDialogUniqueKey, closeViewDialog, viewMode } = useDialogView<IPredictionQuestion>();
  const open = viewDialogUniqueKey === `${PREDICTION_QUESTION_VIEW_DIALOG_KEY}.${viewMode}`;

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "prediction"]} />

      <PageHeader message="pages.prediction.question.title" />

      <SearchWithFilters endAdornment={null} />

      <ProgressOverlay isLoading={isLoading}>
        <StyledListWrapper count={allRows.length} isLoading={isLoading}>
          {allRows.map(question => (
            <StyledListItem key={question.id}>
              <ListItemText sx={{ width: 0.2 }}>{question.title}</ListItemText>
              <ListActions>
                <ListAction
                  onClick={handleView(PREDICTION_QUESTION_VIEW_DIALOG_KEY, question, "action")}
                  message="form.tips.view"
                  icon={Visibility}
                />
              </ListActions>
            </StyledListItem>
          ))}
        </StyledListWrapper>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}

      {viewItem && open && (
        <PredictionQuestionDialogView
          onCancel={closeViewDialog}
          onConfirm={closeViewDialog}
          open={open}
          viewItem={viewItem}
        />
      )}
    </Grid>
  );
};
